<div class="col-sm-12 detail" *ngIf="!isEmpty" style="height: 100%" (click)="common.outSide($event)">
    <div class="header col-sm-12">
      <div class="col-sm-7">
        <h2> Qualification  </h2>
      </div>
      <div class="col-sm-5 text-right">
        <button class="btn-header uppercase" id="close" (click)="closeQual()"> Fermer </button>
        <button class="btn-header uppercase actionPricipal" id="valide" (click)="updateQual()"> Valider </button>
        <!--div>
          <label class="text-left uppercase text-underline historique" (click)="common.getLogs(detail.id, '43', modalService);"> Voir l'historique </label>
          <label class="text-left uppercase text-underline historique">Voir les documents</label>
        </div-->
      </div>
      <div class="col-sm-12" style="padding: 10px 0 0;">
          <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">N° de Registre de commerce :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                  <input  type="text" class="form-control" [(ngModel)]="detail.numRegistreCommerceAmiante">
              </div>
          </div>
          <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">N° de certificat :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                  <input  type="text" class="form-control" [(ngModel)]="detail.numCertificatAmiante">
              </div>
          </div>
      </div>
    </div>
    
    <div class="col-sm-12 ligneBon liste">
        <ngx-datatable  style="height: 100%" class="material" [rows]="listQualification || []" [columnMode]="'force'" [headerHeight]="35"
        [footerHeight]="0" [rowHeight]="30"  [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
        [loadingIndicator]="loadingIndicator" [selected]="selected">
        <ngx-datatable-column  [width]="30" [sortable]="false" [canAutoResize]="false"
            [resizeable]="false">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
                <div class="selecticon" (click)="selectRow(row)" *ngIf="!row.dragstart">
                    <i class="fa fa-ellipsis-v"></i>
                    <i class="fa fa-ellipsis-v" style="margin-left: -2px"></i>
                </div>
                <div class="selecticon" *ngIf="row.dragstart">
                    <i class="fa fa-arrows" aria-hidden="true"></i>
                </div>
            </ng-template>
        </ngx-datatable-column> 
        <ngx-datatable-column name="Libelle" prop="code">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader">
                    <span class="uppercase"> Code </span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template >
                <div class="getID" id="{{rowIndex}}" class="getID">
                    <input type="text" class="input detailfact" id="code{{rowIndex}}"  [(ngModel)]="row.code"
                     autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')">
                </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="denomination">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader">
                    <span class="uppercase">Dénomination</span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <input type="text" class="input detailfact" id="denomination{{rowIndex}}"  [(ngModel)]="row.denomination"
                     autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')">
            </ng-template>
        </ngx-datatable-column>
        
        <ngx-datatable-column name="DateAttribution" prop="dateAttribution">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader">
                    <span class="uppercase"> Date d'attribution </span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <input type="text" id="dateAttribution{{rowIndex}}" class="input detailfact" (click)="focus($event)" [(ngModel)]="row.dateAttribution"
                 autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')"  (ngModelChange)="common.changeDateFormat('dateAttribution', row)" >
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="dateEcheance" prop="dateEcheance">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader">
                    <span class="uppercase"> Date d'échéance </span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <input type="text" id="dateEcheance{{rowIndex}}" class="input detailfact" (click)="focus($event)" 
                [(ngModel)]="row.dateEcheance" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')"  (ngModelChange)="common.changeDateFormat('dateEcheance', row)">
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Frequence" prop="effectif">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader">
                    <span class="uppercase"> Effectif </span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <input type="number" id="effectif{{rowIndex}}" class="input detailfact"
                (click)="focus($event)" [(ngModel)]="row.effectif" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')" >
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Tranche" prop="tranche">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader  text-right">
                    <span class="uppercase"> Tranche </span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <input type="number" id="tranche{{rowIndex}}" class="input detailfact"
                (click)="focus($event)" [(ngModel)]="row.tranche" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')" >
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="50" [sortable]="false" [canAutoResize]="false"
            [draggable]="false" [resizeable]="false">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                <div class="text-center"><button class="btn-detail" (click)="deleteLigne(row)">
                    <i class="fa fa-trash"></i>
                </button></div>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
    </div>
    <div class="addLigne col-sm-12 uppercase">
      <div class="col-sm-7 text-left">
        <button class="btn-add" id="addLigne" (click)="addLigne()">
          <i class="fa fa-plus"></i>
        </button>
        <span>Ajouter une ligne</span>
      </div>
      <label class="text-left uppercase text-underline historique col-sm-5"></label>
    </div>
  </div>
  
  <app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>
  